import '.ce{position:relative;}.ssr-plugin'
import '.i9{width:64px;}.ssr-plugin'
import '.ia{height:64px;}.ssr-plugin'
import '.br{flex-shrink:0;}.ssr-plugin'
import '.o{position:absolute;}.ssr-plugin'
import '.ib{bottom:-4px;}.ssr-plugin'
import '.cr{right:-4px;}.ssr-plugin'
import '.di{border-radius:50%;}.ssr-plugin'
import '.ic{border:2px solid var(--shades-white);}.ssr-plugin'
import '.s{overflow:hidden;}.ssr-plugin'
import '.id{width:32px;}.ssr-plugin'
import '.ie{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="ce i9 ia br"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="o ib cr di ic s id ie"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
